import React from "react"
import {NavLink} from "react-router-dom"
import {ListItemIcon, ListItemText, MenuItem, Tooltip} from "@mui/material"
import menuIcon from "./menuIcons"

/**
 * Menu entry for a CollapsibleDrawer: icon + title when expanded,
 * icon only (with tooltip) when collapsed.
 */
export default function NavMenuItem({to, title, icon, disabled, open, selected = false}) {
    const item = (
        <MenuItem
            component={NavLink}
            to={to}
            disabled={disabled}
            selected={selected}
            sx={{
                minHeight: 40,
                justifyContent: open ? "initial" : "center",
                px: open ? 2 : 0,
                "&.Mui-selected": {
                    color: "primary.main",
                    "& .MuiListItemIcon-root": {color: "primary.main"},
                    "& .MuiListItemText-primary": {fontWeight: 600}
                }
            }}
        >
            <ListItemIcon
                sx={{
                    minWidth: 0,
                    justifyContent: "center",
                    mr: open ? 1.5 : 0
                }}
            >
                {icon ?? menuIcon(title)}
            </ListItemIcon>
            <ListItemText
                primary={title}
                sx={{opacity: open ? 1 : 0, display: open ? "block" : "none"}}
            />
        </MenuItem>
    )

    return open ? item : (
        <Tooltip title={title} placement="right">
            {item}
        </Tooltip>
    )
}
